import { IUserPartial } from "@schemas/issueSchema";
import React, { RefObject, useMemo, useState } from "react";
import { Avatar, McDropdownBase } from "..";
import { filterPattern } from "../../app/utils";

const McDropdownMultiUser: React.FC<{
  allUsers: IUserPartial[];
  selectedUsers: IUserPartial[];
  onChange: (userId: IUserPartial) => void;
  filterActive: boolean;
  container?: string | HTMLElement | RefObject<HTMLElement> | null;
}> = ({ allUsers, selectedUsers, onChange, ...props }) => {
  const [filterValue, setFilterValue] = useState<string>("");
  const userExistInSelectedUser = (userId: string) => selectedUsers?.find((user) => user._id === userId) != null;

  const unSelectedUsers = useMemo(
    () => allUsers.filter((user) => userExistInSelectedUser(user?._id) === false),
    [selectedUsers, allUsers],
  );

  return (
    <McDropdownBase
      {...props}
      multiSelect={true}
      onToggle={() => setFilterValue("")}
      onFilter={(val) => setFilterValue(val)}
      style={{ width: "16em", maxHeight: "40vh", overflow: "auto" }}
      color="white"
    >
      <McDropdownBase.Display>
        <AvatarList users={selectedUsers ?? []} />
      </McDropdownBase.Display>
      {selectedUsers
        ?.filter((u) => {
          const q = filterValue?.trim().toLocaleLowerCase();
          return !q || u.name?.trim().toLocaleLowerCase().includes(q);
        })
        .map((u) => (
          <McDropdownBase.Option
            className="d-flex flex-fill align-items-center"
            key={String(u._id)}
            onClick={() => onChange?.(u)}
          >
            <Avatar id={u._id} name={u.name} size={20} />
            <div className="truncateHeaderText">{u.name}</div>
            <div className="flex-fill" />
            <i className="fa fa-close" />
          </McDropdownBase.Option>
        ))}
      {selectedUsers?.length > 0 && unSelectedUsers?.length > 0 && (
        <McDropdownBase.Option key="mc__divider" divider={true} />
      )}
      {unSelectedUsers?.reduce((acc, user, index) => {
        if (filterValue === "" || filterPattern(filterValue).test(user?.name)) {
          acc.push(
            <McDropdownBase.Option
              className="d-flex align-items-center"
              key={user?._id + index}
              onClick={() => onChange && onChange(user)}
            >
              <Avatar id={user?._id} name={user?.name} size={20} />
              <div className="truncateHeaderText">{user?.name}</div>
            </McDropdownBase.Option>,
          );
        }
        return acc;
      }, [])}
    </McDropdownBase>
  );
};

export default McDropdownMultiUser;

const AvatarList: React.FC<{ users: IUserPartial[] }> = ({ users }) => {
  return (
    <div className="d-flex w-100 truncateHeaderText">
      {users?.map((user) => (
        <div key={user._id} title={user.name}>
          <Avatar id={user?._id} name={user?.name} size={20} />
        </div>
      ))}
    </div>
  );
};
